import { MouseEvent, useEffect, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";

import { AttachmentModel } from "@interfaces/index";
import { getFileExtension } from "@utils/index";

export const FilePreview = ({
  attachment,
  onClose,
}: {
  attachment?: AttachmentModel;
  onClose?: () => void;
}) => {
  const [file, setFile] = useState<{
    ext: string;
    url: string;
  }>();
  const [numPages, setNumPages] = useState<number | null>(null);

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      "pdfjs-dist/build/pdf.worker.min.mjs",
      import.meta.url,
    ).toString();
  }, []);

  useEffect(() => {
    if (attachment) {
      setFile({
        ext: getFileExtension(attachment),
        url: attachment.url,
      });
    }
  }, [attachment]);

  const handleClosePreview = (event: MouseEvent<HTMLElement>) => {
    if (!(event.target as HTMLElement).closest("#file-preview")) {
      setFile(undefined);
      if (onClose) {
        onClose();
      }
    }
  };

  return (
    !!file && (
      <div
        className="fixed inset-0 z-10 flex items-center justify-center bg-black-54 p-4"
        onClick={handleClosePreview}
      >
        <div
          id="file-preview"
          className="max-h-[80%] max-w-[80%] overflow-y-auto rounded-lg bg-white-100"
        >
          {file.ext === "pdf" ? (
            <Document
              file={file}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            >
              {Array(numPages)
                .fill(null)
                .map((_, i) => i + 1)
                .map((page) => (
                  <Page
                    key={`page_${page}`}
                    pageNumber={page}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                    renderMode="canvas"
                  />
                ))}
            </Document>
          ) : (
            <img src={file.url} alt="Receipt" />
          )}
        </div>
      </div>
    )
  );
};
